

export const updateAssessmentNumberParam  = (payload) =>{
    return{
        type:'UPDATE_ASSESSEMENT_NUMBER',
        payload:payload
    }
}

